// Mock data for Helper-Schweiz website

export const companyInfo = {
  name: "Helper-Schweiz",
  tagline: "Haushaltsauflösung • Entrümpeln • Entsorgung",
  owner: "Christian Reinhardt",
  phone: "+41 77 252 38 20",
  email: "info@helper-schweiz.ch",
  address: "Seestrasse 45, 8596 Scherzingen",
  region: "Kanton Thurgau",
  extendedRegion: "Auf Anfrage ganze Deutschschweiz",
  logo: "https://customer-assets.emergentagent.com/job_3719f4ac-329a-4fbd-ac62-64e6b9283120/artifacts/w6h2b9cu_69ee4fc1-4e0e-4bea-baed-6f8676663201.jpg",
  whatsappQR: "https://customer-assets.emergentagent.com/job_3719f4ac-329a-4fbd-ac62-64e6b9283120/artifacts/fc1odvf2_qr%20code%20WP.jpg",
  vehicleImage: "https://customer-assets.emergentagent.com/job_aaa9f090-7328-45ff-82d7-e3a04de99f10/artifacts/kpumiihu_heckansicht.jpg"
};

export const services = [
  {
    id: 1,
    title: "Entrümpelung",
    description: "Professionelle Entrümpelung von Häusern, Wohnungen und Liegenschaften",
    icon: "Trash2"
  },
  {
    id: 2,
    title: "Haushaltsauflösung",
    description: "Komplette Haushaltsauflösungen mit Sorgfalt und Diskretion",
    icon: "Home"
  },
  {
    id: 3,
    title: "Estrich & Keller",
    description: "Räumung und Entsorgung von Estrich, Keller und Lagerräumen",
    icon: "Archive"
  },
  {
    id: 4,
    title: "Garage",
    description: "Professionelle Garagen-Räumung und Organisation",
    icon: "Car"
  },
  {
    id: 5,
    title: "Nachlassauflösung",
    description: "Einfühlsame Nachlassauflösungen mit Respekt und Professionalität",
    icon: "Heart"
  },
  {
    id: 6,
    title: "Möbel Demontage",
    description: "Fachgerechte Demontage und Entsorgung von Möbeln",
    icon: "Wrench"
  }
];

export const allServices = [
  ...services,
  {
    id: 7,
    title: "Fachgerechte Entsorgung",
    description: "Umweltgerechte Entsorgung und Recycling aller Materialien",
    icon: "Recycle"
  },
  {
    id: 8,
    title: "Besenrein Optional",
    description: "Abschlussreinigung für übergabebereite Objekte",
    icon: "Sparkles"
  },
  {
    id: 9,
    title: "Wertanrechnung",
    description: "Faire Wertanrechnung für verwertbare Gegenstände möglich",
    icon: "Coins"
  },
  {
    id: 10,
    title: "Schrott & Altmetall",
    description: "Abholung und fachgerechte Entsorgung von Schrott und Altmetall",
    icon: "Factory"
  },
  {
    id: 11,
    title: "Allrounder Service",
    description: "Vielseitige Unterstützung bei verschiedenen Aufgaben rund ums Haus und Wohnen",
    icon: "Star"
  }
];

export const benefits = [
  {
    id: 1,
    title: "Persönlich & Zuverlässig",
    description: "Als Einzelunternehmer bin ich persönlich für Sie da und setze jeden Auftrag sorgfältig um",
    icon: "User"
  },
  {
    id: 2,
    title: "Faire Preise",
    description: "Transparente Kostenvoranschläge und faire Wertanrechnung bei verwertbaren Gegenständen",
    icon: "BadgeSwissFranc"
  },
  {
    id: 3,
    title: "Umweltgerecht",
    description: "Fachgerechte Entsorgung und Recycling aller Materialien",
    icon: "Leaf"
  },
  {
    id: 4,
    title: "Flexibel & Effizient",
    description: "Ideal für kleine bis mittlere Entrümpelungen - grössere Projekte auf Anfrage",
    icon: "Zap"
  }
];

export const idealFor = [
  "Kleine bis mittlere Wohnungen (1-3 Zimmer)",
  "Estrich, Keller, Garagen",
  "Teilentrümpelungen einzelner Räume",
  "Schrott- und Altmetallentsorgung",
  "Möbeldemontage und -entsorgung"
];

export const onRequest = [
  "Grössere Wohnungen & Häuser",
  "Komplette Haushaltsauflösungen",
  "Umfangreiche Nachlassauflösungen",
  "Projekte ausserhalb Kanton Thurgau"
];

export const serviceOptions = [
  { value: "", label: "Bitte wählen" },
  { value: "entruempelung", label: "Entrümpelung" },
  { value: "haushaltsaufloesung", label: "Haushaltsauflösung" },
  { value: "nachlassaufloesung", label: "Nachlassauflösung" },
  { value: "entsorgung", label: "Entsorgung" },
  { value: "andere", label: "Andere" }
];

export const objectOptions = [
  { value: "", label: "Bitte wählen" },
  { value: "wohnung", label: "Wohnung" },
  { value: "haus", label: "Haus" },
  { value: "estrich", label: "Estrich" },
  { value: "keller", label: "Keller" },
  { value: "garage", label: "Garage" },
  { value: "andere", label: "Andere" }
];

export const values = [
  {
    id: 1,
    title: "Leidenschaft",
    description: "Ich liebe was ich tue und setze mich mit vollem Einsatz für meine Kunden ein",
    icon: "Heart"
  },
  {
    id: 2,
    title: "Vertrauen",
    description: "Diskretion und Zuverlässigkeit sind die Grundpfeiler meiner Arbeit",
    icon: "Shield"
  },
  {
    id: 3,
    title: "Professionalität",
    description: "Fachgerechte Ausführung und zuverlässige Arbeit garantieren beste Resultate",
    icon: "Award"
  }
];

export const promises = [
  "Persönlicher Ansprechpartner von Anfang bis Ende",
  "Spezialisiert auf kleine bis mittlere Entrümpelungen",
  "Grössere Projekte auf Anfrage",
  "Transparente Kommunikation und faire Kostenvoranschläge",
  "Umweltgerechte Entsorgung und Recycling",
  "Faire Wertanrechnung bei verwertbaren Gegenständen",
  "Optionale Endreinigung für übergabebereite Objekte",
  "Diskretion und Respekt bei jeder Aufgabe"
];

export const images = {
  // Bilder die zur Entrümpelung passen
  vollKeller: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800",
  kartons: "https://images.unsplash.com/photo-1600566752355-35792bedcfea?w=800",
  altmoebel: "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=800",
  leerRaum: "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800",
  transporter: "https://images.unsplash.com/photo-1519003722824-194d4455a60c?w=800",
  muell: "https://images.unsplash.com/photo-1532996122724-e3c354a0b15b?w=800",
  werkzeug: "https://images.unsplash.com/photo-1581147036324-c17ac41f3e6f?w=800",
  handwerk: "https://images.unsplash.com/photo-1504148455328-c376907d081c?w=800"
};
